import { Injectable, inject } from "@angular/core";
import { RouterStateSnapshot, TitleStrategy } from "@angular/router";
import { PageTitleService } from "./page-title.service";

/**
 * Applies each route's `title` through PageTitleService so every module gets
 * its own tab title instead of the static one from `index.html`.
 */
@Injectable({ providedIn: "root" })
export class AppTitleStrategy extends TitleStrategy {
  private readonly pageTitle = inject(PageTitleService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.pageTitle.setRouteTitle(this.buildTitle(snapshot));
  }
}
